import * as React from "react";
import { SVGProps } from "react";

const FtxToken = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1739" {...props}>
    <path
      fill="#02a6c2"
      d="M565.41.11q717.21-.22 1434.51 0 .22 231.83 0 463.58-717.23.22-1434.51 0-.23-231.83 0-463.58Z"
    />
    <path
      fill="#5fcade"
      d="M.6 638.1q231.39-1.2 462.86 0 1.2 231.39 0 462.86Q232 1102.15.6 1101-.6 869.57.6 638.1Zm565.17 0q517.67-1.1 1035.27 0 1.1 231.39 0 462.86-517.66 1.08-1035.27 0-1.08-231.4 0-462.86Z"
    />
    <path
      fill="#abebf4"
      d="M566.2 1276.23q231-2.51 461.92 0 2.4 230.85.07 461.92-231 2.28-461.91-.08-2.4-230.83-.08-461.84Z"
    />
  </svg>
);

export default FtxToken;
